/*
  This script is responsible for detecting when the cloudlift app features get injected to the dom.
  In this case we want to know when exactly the personalizer popup appears using a MutationObserver.
  Further logic is to be implemented.
  
  At the moment the script just detects DOM changes, it does not modify anything.
*/

// target node
var bodyElement = document.querySelector("body");

// observer instance
var observer = new MutationObserver(function (mutations) {
  mutations.forEach(function (mutation) {
    if (mutation.addedNodes && mutation.addedNodes.length > 0) {
      for (var i = 0; i < mutation.addedNodes.length; i++) {
        var addedNode = mutation.addedNodes[i];

        if (
          addedNode.nodeType === 1 &&
          addedNode.classList.contains("cl-po--option") &&
          (!addedNode.getAttribute("data-option") ||
            (addedNode.getAttribute("data-option") !== "_2pc_clothing_id" &&
              addedNode.getAttribute("data-option") !== "_3pc_clothing_id" &&
              addedNode.getAttribute("data-option") !== "group_personalize"))
        ) {
          const event = new CustomEvent("customizer:added:options", {
            detail: { element: addedNode }
          });
          window.dispatchEvent(event);
        }

        if (
          addedNode.nodeType === 1 &&
          addedNode.querySelector(".ldcv .base .inner .cl-po--popup")
        ) {
          // console.log('Element with class .cl-po--popup found in body.');

          const event = new CustomEvent("customizer:injected", {
            detail: { element: addedNode }
          });
          window.dispatchEvent(event);

          return; // Stop if element found
        }
      }
    }

    // Check for removed nodes
    if (mutation.removedNodes && mutation.removedNodes.length > 0) {
      for (var i = 0; i < mutation.removedNodes.length; i++) {
        var removedNode = mutation.removedNodes[i];

        if (
          removedNode.nodeType === 1 &&
          removedNode.classList &&
          removedNode.classList.contains("cl-po--option") &&
          (!removedNode.getAttribute("data-option") ||
            (removedNode.getAttribute("data-option") !== "_2pc_clothing_id" &&
              removedNode.getAttribute("data-option") !== "_3pc_clothing_id" &&
              removedNode.getAttribute("data-option") !== "group_personalize"))
        ) {
          const event = new CustomEvent("customizer:removed:options", {
            detail: { element: removedNode }
          });
          window.dispatchEvent(event);
        }
      }
    }
  });
});

// observer config
var config = { childList: true, subtree: true };

// Start observing the target node
observer.observe(bodyElement, config);

/*
  Event listener: customize:injected
  Purpose: Insert show more/show less buttons and reduces option
  count to a defined MAX_ITEM_COUNT if applicable 
*/
window.addEventListener("customizer:injected", () => {
  const MAX_ITEM_COUNT = 30;
  const elems = document.querySelectorAll(
    `[data-option="_jacket_last_sleeve_buttonhole_thread_color"],
    [data-option="_lining_color"],
    [data-option="_pants_button_color"],
    [data-option="_jacket_button_color"]`
  );

  elems.forEach((elem, index) => {
    const swatchContainer = elem.querySelector(".cl-po--swatch-container");
    const children = Array.from(swatchContainer.children);
    const childCount = children.length;

    if (childCount > MAX_ITEM_COUNT) {
      children.forEach((child, i) => {
        if (i >= MAX_ITEM_COUNT) {
          child.classList.add("hidden-important");
        }
      });

      const showMoreBtn = document.createElement("button");
      showMoreBtn.textContent = "Show More";
      showMoreBtn.setAttribute("id", `showMoreBtn-${index}`);
      showMoreBtn.classList.add(
        "cl-po--swatch",
        "cl-po--swatch-button",
        "cl-po--small",
        "button--show-more"
      );

      showMoreBtn.addEventListener("click", function () {
        const isExpanded = showMoreBtn.textContent === "Show Less";

        if (isExpanded) {
          children.forEach((child, i) => {
            if (i >= MAX_ITEM_COUNT) {
              child.classList.add("hidden-important");
            }
          });
          showMoreBtn.textContent = "Show More";
        } else {
          children.forEach((child) => {
            child.classList.remove("hidden-important");
          });
          showMoreBtn.textContent = "Show Less";
        }
      });

      swatchContainer.parentElement.appendChild(showMoreBtn);
    }
  });
});

/*
  Event listener: customize:injected
  Purpose: paginate content and add steps
*/
window.addEventListener("customizer:injected", () => {
  refreshOptionsList();
});

/*
  Event listener: customizer:added:options
*/
window.addEventListener("customizer:added:options", (e) => {
  // console.log("Options added", e.detail.element);
  refreshOptionsList();
});

/*
  Event listener: customizer:removed:options
*/
window.addEventListener("customizer:removed:options", (e) => {
  // console.log("Options removed", e.detail.element);
  refreshOptionsList();
});

window.addEventListener("customizer:options:prev", (e) => {
  // console.log("Prev button clicked");
});

window.addEventListener("customizer:options:next", (e) => {
  // console.log("Next button clicked");
});

/*
  Function that gets the options list
*/
function refreshOptionsList() {
  const mainContainer = document.querySelector(".cl-po--popup-options");
  const personalizeGroup = mainContainer.querySelector(
    '[data-option="group_personalize"]'
  );
  const optionsContainer = personalizeGroup.querySelector(".cl-po--group");
  const children = optionsContainer.children;

  optionsContainer.style.position = "relative";

  const filteredArray = Array.from(children).filter((option) => {
    const dataOption = option.getAttribute("data-option");
    return (
      !dataOption ||
      !dataOption.includes("_") ||
      dataOption.includes("_include_vest")
    );
  });

  const pageCount = filteredArray.length;

  filteredArray.forEach((filteredOption, index) => {
    filteredOption.setAttribute("data-option-index", index);
  });

  // don't build navigationElement if controls element already exists
  // if (document.querySelector(".option--controls")) return;

  createControlsElement();
  createPageCountElement(pageCount);
  createNavigationElement(pageCount, filteredArray);
}

function createControlsElement() {
  const parentEl = document.querySelector(".options-atc");
  const controlsEl = document.createElement("div");
  controlsEl.classList.add("option--controls");
  parentEl.appendChild(controlsEl);
}

function createPageCountElement(pageCount) {
  const pageCountInDOM = document.querySelector(".options__page-count");

  if (pageCountInDOM) {
    const currentPage = parseInt(pageCountInDOM.innerHTML.split(" / ")[0], 10);
    pageCountInDOM.innerHTML = `${currentPage} / ${pageCount}`;

    return;
  }

  const parentEl = document.querySelector(".option--controls");
  const pageCountWrapper = document.createElement("div");
  const pageCountLabel = document.createElement("span");
  const pageCountEl = document.createElement("span");

  pageCountWrapper.classList.add("list-flex", "spacer");

  pageCountLabel.classList.add("options__page-label", "h2", "product__title");
  pageCountLabel.innerHTML = "Step";

  pageCountEl.classList.add("options__page-count", "h2", "product__title");
  pageCountEl.setAttribute("data-page-count", pageCount);
  pageCountEl.innerHTML = "1 / " + pageCount;

  pageCountWrapper.appendChild(pageCountLabel);
  pageCountWrapper.appendChild(pageCountEl);

  parentEl.appendChild(pageCountWrapper);
}

function createNavigationElement(pageCount) {
  const pageCountInDOM = document.querySelector(".options__page-count");
  const controlsInDOM = document.querySelector(".options--prev");
  let currentPage = 1;

  if (pageCountInDOM) {
    currentPage = parseInt(pageCountInDOM.innerHTML.split(" / ")[0], 10);
  }

  const parentEl = document.querySelector(".option--controls");
  const navEl = document.createElement("div");
  const navPrev = document.createElement("span");
  const navNext = document.createElement("span");
  const buyButton = document.querySelector(".atc-button");

  navEl.classList.add("list-flex", "spacer");
  navPrev.classList.add("options--prev");
  navNext.classList.add("options--next");

  const pageCountEl = document.querySelector(".options__page-count");
  const optionsContainer = document.querySelector(".cl-po--group");
  const options = Array.from(optionsContainer.children).filter((option) =>
    option.hasAttribute("data-option-index")
  );

  function updatePageCount() {
    pageCountEl.innerHTML = `${currentPage} / ${pageCount}`;
  }

  function showActiveOption() {
    options.forEach((option, index) => {
      if (index + 1 === currentPage) {
        option.style.display = "block";
      } else {
        option.style.display = "none";
      }
    });
  }

  function toggleBuyButton() {
    if (currentPage === pageCount) {
      buyButton.style.opacity = "1";
      buyButton.style.pointerEvents = "auto";
    } else {
      buyButton.style.opacity = "0";
      buyButton.style.pointerEvents = "none";
    }
  }

  // Initialize first visible option
  showActiveOption();
  toggleBuyButton();

  navPrev.addEventListener("click", () => {
    if (currentPage > 1) {
      currentPage--;
      updatePageCount();
      showActiveOption();
      toggleBuyButton();
      const event = new CustomEvent("customizer:options:prev", {
        detail: { page: currentPage }
      });
      window.dispatchEvent(event);
    }
  });

  navNext.addEventListener("click", () => {
    if (currentPage < pageCount) {
      currentPage++;
      updatePageCount();
      showActiveOption();
      toggleBuyButton();
      const event = new CustomEvent("customizer:options:next", {
        detail: { page: currentPage }
      });
      window.dispatchEvent(event);
    }
  });

  const nextButton = document.querySelector(".options--next");
  const prevButton = document.querySelector(".options--prev");

  if (nextButton || prevButton) {
    nextButton.remove();
    prevButton.remove();
  }

  navEl.appendChild(navPrev);
  navEl.appendChild(navNext);
  parentEl.appendChild(navEl);
}
